import { Button } from '@/components/ui/button'
import { CopyField } from '@/components/ui/copy-field'
import { Dialog, DialogContent } from '@/components/ui/dialog'

/** One-time reveal of an admin-issued temporary password. */
export function TempPasswordDialog({ reveal, onClose }: { reveal: { email: string; password: string } | null; onClose: () => void }) {
  return (
    <Dialog open={!!reveal} onOpenChange={(o) => !o && onClose()}>
      <DialogContent title="Temporary password" description={reveal ? `For ${reveal.email}` : undefined} className="max-w-lg">
        <CopyField value={reveal?.password ?? ''} />
        <p className="mt-3 text-xs text-ata-orange">Share this out-of-band. The user must change it on first login. It won't be shown again.</p>
        <Button variant="secondary" className="mt-4 w-full" onClick={onClose}>
          Done
        </Button>
      </DialogContent>
    </Dialog>
  )
}
